import { StoryGroup } from "@/@types/stories.types";
import { StoryAvatar } from "./StoryAvatar";

interface StoriesBarProps {
  storyGroups: StoryGroup[];
  viewedGroups: Set<string>;
  onStoryClick: (groupIndex: number) => void;
  isLoading?: boolean;
}

function StoriesBarSkeleton() {
  return (
    <div className="scrollbar-hide mb-4 overflow-x-auto">
      <div className="flex gap-3 px-1 py-2">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex flex-shrink-0 flex-col items-center gap-1.5">
            <div className="h-[70px] w-[70px] animate-pulse rounded-full bg-gray-200" />
            <div className="h-3 w-14 animate-pulse rounded bg-gray-200" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function StoriesBar({
  storyGroups,
  viewedGroups,
  onStoryClick,
  isLoading,
}: StoriesBarProps) {
  if (isLoading) return <StoriesBarSkeleton />;
  if (storyGroups.length === 0) return null;

  return (
    <div className="scrollbar-hide mb-4 overflow-x-auto">
      <div className="flex gap-3 px-1 py-2">
        {storyGroups.map((group, index) => (
          <StoryAvatar
            key={group.id}
            avatarUrl={group.avatarUrl}
            name={group.name}
            viewed={viewedGroups.has(group.id)}
            onClick={() => onStoryClick(index)}
          />
        ))}
      </div>
    </div>
  );
}
